import React from "react";
import { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";

import { ROUTES } from "../../constants";
import { isLoggedIn } from "../authContext";
import { EVENT_LOCAL_STORAGE_LOGIN } from "../events";

export const PrivateRoute = () => {
  const [isAuth, setIsAuth] = useState<boolean>(isLoggedIn);
  React.useEffect(() => {
    window.addEventListener(EVENT_LOCAL_STORAGE_LOGIN, () => {
      setIsAuth(isLoggedIn());
    });
  }, [isLoggedIn()]);
  useEffect(() => {
    setIsAuth(isLoggedIn());
  }, [isLoggedIn()]);
  return isAuth ? <Outlet /> : <Navigate to={ROUTES.HOME} />;
};
